// The user manual and version history ship inside the bundle as plain text, so
// they work offline and need no extra request (the CSP allows only 'self').
import history from '../../CHANGELOG.TXT?raw';
import manual from '../../USER_MANUAL.TXT?raw';

export const DOCS = {
  manual: { title: 'Help — SID2MIDI Web user manual', text: manual },
  history: { title: 'Version history', text: history },
} as const;

export type DocId = keyof typeof DOCS;
